export default __webpack_public_path__ + "static/media/vip5.4cc9c2ca.webp";